import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { IconFilePlus02 } from "@pentabd/icons";
import { Button, Table } from "@pentabd/ui";

import { TableColumn } from "./TableColumn";
// import ButtonGroup from '@components/ButtonGroup';

import { useGpfHistory } from "@hooks/HRM/gpfHistory/useGpfHistory";

import { ROUTES } from "@constants/routes";

interface GpfHistoryTableProps {
  id: string | number | undefined;
  isEditEmployee: boolean;
}

export const GpfHistoryTable = ({
  id,
  isEditEmployee,
}: GpfHistoryTableProps) => {
  const { t } = useTranslation();
  const { gpfHistory } = useGpfHistory(id ? Number(id) : null);

  // const filterButtons = [
  //   t('GPF.TABLE_BUTTONS.VIEW_BUTTON'),
  //   t('GPF.TABLE_BUTTONS.APPROVED_BUTTON'),
  //   t('GPF.TABLE_BUTTONS.PENDING_BUTTON'),
  // ];

  // const btnGroupAction = (index: number) => {
  //   setActiveStatus(index);
  //   dispatch(getRetirementHistoryRequest(index));
  // };

  return (
    <Table
      header={{
        title: t("GPF_HISTORY.TABLE.HEADER"),
        buttons: [
          <Link to={`/gpf/${id}/${ROUTES.CREATE}`}>
            <Button
              fill="fill"
              size="sm"
              type="default"
              htmlType="button"
              className="bg-primary-lightest text-primary-middark border border-primary-lighter"
              disabled={isEditEmployee}
            >
              <IconFilePlus02 size="20" fill="info" />
              {t("PROVIDENT_FUND.TABLE.ADD_BUTTON_TEXT")}
            </Button>
          </Link>,
        ],
      }}
      columns={TableColumn(t, id)}
      rows={gpfHistory}
      // headerExtension={{
      //   leftComponents: [
      //     <ButtonGroup
      //       key="btn-group"
      //       btnGroupData={filterButtons}
      //       activeState={activeStatus}
      //       action={btnGroupAction}
      //     />,
      //   ],
      // }}
    />
  );
};
